/** Status pill class for investor portfolio / holdings rows. */
export function investorLifecyclePillClass(status) {
  const s = String(status || "").toUpperCase();
  if (["FUNDING", "LOCK_IN"].includes(s)) return "investor-status-pill investor-status-pill--info";
  if (["FUNDED", "ACTIVE"].includes(s)) return "investor-status-pill investor-status-pill--success";
  if (["REDEEMED", "COMPLETED"].includes(s)) return "investor-status-pill investor-status-pill--neutral";
  if (["CANCELLED", "PAUSED"].includes(s)) return "investor-status-pill investor-status-pill--danger";
  return "investor-status-pill investor-status-pill--neutral";
}
